<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <div class="container text-left mt-2 mb-2 text-playgame">
        คำถามที่พบบ่อย
      </div>
      <div class="faq-container">
        <div v-for="(data, i) in faqData" :key="i" @click="data.expand = !data.expand" >
          <div class="d-flex justify-content-between question-container">
            Q: {{ data.question }}
            <div class="expand-icon">
              <div v-if="data.expand">
                <font-awesome-icon
                  class="user-info-user-icon"
                  :icon="['fa', 'minus']"
                />
              </div>
              <div v-else>
                <font-awesome-icon
                  class="user-info-user-icon"
                  :icon="['fa', 'plus']"
                />
              </div>
            </div>
          </div>
          <b-collapse id="collapse-4" v-model="data.expand">
            <b-card class="answer-content">A: {{ data.answer }}</b-card>
          </b-collapse>
        </div>
      </div>
    </div>
    <div class="maincontent-bg-end"></div>
  </div>
</template>

<script>
export default {
  name: 'faq',
  data() {
    return {
      showCollapse: false,
      faqData: [
        {
          id: 'q01',
          question: 'ลืมรหัสผ่านใช่หรือไม่',
          answer:
            'หากคุณลืมรหัสผ่านบัญชีให้คลิกปุ่ม “ลืมรหัสผ่าน” ในเว็บไซต์ ป้อนที่อยู่อีเมลของคุณและจะได้รับอีเมลอัตโนมัติพร้อมลิ้งเพื่อแก้ไขรหัสผ่านใหม่',
          expand: false,
        },
        {
          id: 'q02',
          question: 'อายุน้อยกว่าที่กฎหมายกำหนด สามารถเล่นได้หรือไม่',
          answer:
            'บุคคลที่มีอายุไม่ถึงเกณฑ์ตามที่กฎหมายกำหนด (โดยไม่คำนึงถึงสัญชาติ) จะไม่สามารถใช้บริการของเว็บไซต์ได้ เนื่องจากเป็นการขัดต่อกฎหมายของประเทศที่เซิร์ฟเวอร์เว็บตั้งอยู่',
          expand: false,
        },
        {
          id: 'q03',
          question: 'ฉันสามารถเปลี่ยนชื่อได้หรือไม่',
          answer:
            'ขออภัย ผู้เล่นไม่สามารถแก้ไขชื่อที่ลงทะเบียนได้ นั่นเป็นเหตุผลที่เราขอให้คุณระบุข้อมูลที่ถูกต้องเมื่อสร้างบัญชีของคุณอย่างรอบคอบ',
          expand: false,
        },
        {
          id: 'q04',
          question: 'รับไอเทมหรือของขวัญในเกมส์แล้วไม่ขึ้น',
          answer:
            'ให้ท่านผู้เล่นกดไปที่ รายละเอียดของ ตัวละคร หากยอดไม่ขึ้น ให้ออกจากระบบและเข้าใหม่ หากทำครบตามขั้นตอนแล้วยอดเงินยังไม่ขึ้น ให้ท่านติดต่อแอดมิน',
          expand: false,
        },
        {
          id: 'q05',
          question: 'สามารถเล่นรหัสเดียวกันซ้ำ สองเครื่องได้ไหม',
          answer: 'ไม่สามารถเล่นรหัสเดียวกัน ในเวลาเดียวกันได้',
          expand: false,
        },
        {
          id: 'q06',
          question: 'ปุ่มรับของขวัญในเกมส์หาย',
          answer:
            'หากปุ่มรับไอเทมของขวัญหาย ให้ท่านกดออกไปยังหน้าล็อบบี้ และกดเข้ามาอีกครั้ง หากปุ่มยังไม่ขึ้นให้ติดต่อไปยังแอดมิน',
          expand: false,
        },
        {
          id: 'q07',
          question: 'กดเริ่มเกมส์แล้วไม่ทำงาน หรือ หน้าจอค้างเป็นสีดำ',
          answer:
            'หากเกิดปัญหาในคอมพิวเตอร์ ให้ลองล้างแคชของเบราวเซอร์เพื่อดำเนินการเข้าสู่ระบบใหม่อีกครั้ง ปิดใช้งานโปรแกรมป้องกันไวรัสหรือโปรแกรมบล็อกอื่นๆ ที่อาจรบกวนการทำงานที่ถูกต้องของเกมส์ หากเกิดปัญหากับ Application บนโทรศัพท์มือถือให้ลองลบ App แล้วโหลดเพื่อเข้าสู่ระบบอีกครั้ง',
          expand: false,
        },
        {
          id: 'q08',
          question: 'หากกรอกข้อมูล ID ผิดแก้ไขยังไง',
          answer: 'หากท่านกรอกข้อมูลผิดให้แจ้งเรื่องไปยังแอดมินในทันที',
          expand: false,
        },
        {
          id: 'q09',
          question: 'สามารถเล่นเกมส์ผ่านมือถือได้หรือไม่',
          answer: 'สามารถเล่นบน IOS และ Android ได้อย่างไม่มีข้อบกพร่อง',
          expand: false,
        },
        {
          id: 'q10',
          question:
            'ฉันจะมั่นใจได้อย่างไรว่าเกมส์ของ Ambpoker จะไม่ปิดหนี หรือโกง',
          answer:
            'มั่นใจได้เลยเพราะ Ambpoker เป็นบริษัทที่ถูกต้องตามกฎหมาย เปิดบริการมาเป็นเวลานาน บริษัทมีความมั่นคงทางการเงินสูงและสภาพคล่องดี ไม่เคยมีประวัติโกงลูกค้าตั้งแต่เริ่มให้บริการ การันตีด้วยฐานลูกค้าที่ไว้วางใจนับหมื่น ทั้งไทยและต่างประเทศ',
          expand: false,
        },
        {
          id: 'q11',
          question: 'ทำไมไม่สามารถเข้าเว็บไซต์ได้',
          answer:
            'การเข้าเว็บไซต์ไม่ได้อาจมาจากโปรแกรมที่ใช้เปิด ท่านอาจจะลองเปลี่ยนโปรแกรมหรือทำการปิดระบบป้องกันสแกนไวรัสดู',
          expand: false,
        },
        {
          id: 'q12',
          question: 'หากเป็นมือใหม่จะเริ่มเล่นเกมส์อะไรก่อนดี',
          answer:
            'หากคุณเป็นผู้เล่นมือใหม่ คุณไม่ต้องกังวลว่าจะเล่นไม่เป็น เพราะทางเกมส์ของเรา มีตัวอย่างเกมส์อย่างละเอียด และกฎต่าง ๆ ที่ผู้เล่นสามารถอ่านและทำความเข้าใจได้อย่างรวดเร็ว เกมที่แนะนำสำหรับมือใหม่ คือ ป๊อกเด้ง น้ำเต้าปูปลา ไฮโล เป็นต้น',
          expand: false,
        },
        {
          id: 'q13',
          question: 'จั่วไพ่ไปแล้วชนะแต่ห้องค้างยอดเงินไม่ขึ้นต้องทำอย่างไร',
          answer:
            'หากเล่นในคอมพิวเตอร์ให้ทำการกด F5 เพื่อรีเฟรชหน้าจอ หรือ ใน Application ให้ทำการกดออกโปรแกรมแล้วกดเข้าใหม่ หากยังพบปัญหาเดิมให้ทำการติดต่อไปยังแอดมิน',
          expand: false,
        },
        {
          id: 'q14',
          question: 'วิธีการปิดบัญชี',
          answer: 'เพื่อบล็อกบัญชีของคุณ กรุณาติดต่อแอดมิน',
          expand: false,
        },
      ],
    };
  },
};
</script>

<style scoped>
.faq-container {
  text-align: left;
}
.question-container {
  background-color: #143d2a;
  color: #f7f7f7;
  border-radius: 5px;
  margin: 2px;
  padding: 1rem 3rem;
}
.answer-content {
  background-color: transparent;
  color: #f2ca4e;
  padding: 0 2rem;
}
.expand-icon {
  font-size: 1rem;
}
.btn {
  color: #43de84;
}
@media only screen and (max-width: 576px) {
  .question-container {
    padding: 1rem;
  }
  .answer-content {
    padding: 0rem;
  }
}
</style>
